import {Fragment, useState} from 'react';
import {useHistory} from 'react-router-dom';
import appConstants from '../../../../../constants';
import { KEYS } from '../../../../../l18n/constants';
import { useL18nContext } from '../../../ContextProvider/L18n';
import {useNavigationBetweenPartnerFeaturesContext} from '../../../ContextProvider/Navigation/BetweenPartnerFeatures';
import {usePartnerSearchContext} from '../../../ContextProvider/Partner/Search';
import computeClassName from '../../../../../utils/computeClassName';
import handleClick from '../../../../../utils/handleClick';
import handleEventClick from '../../../../../utils/handleEventClick';
import CCIconClose20x20 from '../../../../libs/CiscoCore/Icon/Close/20x20';
import PartnerLogo from '../../../Partner/Logo';


const constants = Object.freeze({
  CLASSNAME_BASE: 'bg-cc-secondary text-cc-secondary-contrast px-4 py-4 3xs:px-16 3xs:py-8 flex flex-col w-full relative',
  CLASSNAME_CLOSE_LOGO_NAME: 'sticky top-0 bg-cc-primary p-4 pt-12',
  CLASSNAME_SPECIALIZATION: 'px-4 bg-cc-primary',
  CLASSNAME_ROLE: 'px-4 pt-12 bg-cc-primary',
  CLASSNAME_TECHNOLOGY: 'px-4 pt-12 bg-cc-primary',
  CLASSNAME_LEVEL: 'px-4 pt-12 bg-cc-primary',
  CLASSNAME_DESCRIPTION: 'px-4 pt-12 bg-cc-primary',
  CLASSNAME_DIVERSITY: 'px-4 pt-12 bg-cc-primary pb-12',
  CLASSNAME_GAP_HEADER: '',
  CLASSNAME_GAP: '',
  NO_EXPERTISES:'no expertises'
});


function getComputedCloseLogoNameClassName(partnerIndex) {
  return `pf-c-grid-comparator__closeLogoName${partnerIndex} ${constants.CLASSNAME_CLOSE_LOGO_NAME}`.trim();
}
function getComputedSpecializationClassName(partnerIndex) {
  return `pf-c-grid-comparator__specialization${partnerIndex} ${constants.CLASSNAME_SPECIALIZATION}`.trim();
}
function getComputedRoleClassName(partnerIndex) {
  return `pf-c-grid-comparator__role${partnerIndex} ${constants.CLASSNAME_ROLE}`.trim();
}
function getComputedTechnologyClassName(partnerIndex) {
  return `pf-c-grid-comparator__technology${partnerIndex} ${constants.CLASSNAME_TECHNOLOGY}`.trim();
}
function getComputedIndustryClassName(partnerIndex) {
  return `pf-c-grid-comparator__industry${partnerIndex} ${constants.CLASSNAME_TECHNOLOGY}`.trim();
}
function getComputedLevelClassName(partnerIndex) {
  return `pf-c-grid-comparator__level${partnerIndex} ${constants.CLASSNAME_LEVEL}`.trim();
}
function getComputedDescriptionClassName(partnerIndex) {
  return `pf-c-grid-comparator__description${partnerIndex} ${constants.CLASSNAME_DESCRIPTION}`.trim();
}
function getComputedDiversityClassName(partnerIndex) {
  return `pf-c-grid-comparator__diversity${partnerIndex} ${constants.CLASSNAME_DIVERSITY}`.trim();
}
function getComputedGapHeader(partnerIndex) {
  return `pf-c-grid-comparator__gapHeader${partnerIndex} ${constants.CLASSNAME_GAP_HEADER}`.trim();
}
function getComputedGap(partnerIndex) {
  return `pf-c-grid-comparator__gap${partnerIndex} ${constants.CLASSNAME_GAP}`.trim();
}

function navigateToPartnerProfile(navigationParams) {
  navigationParams.history.push(`/partner/${navigationParams.partnerId}`);
}

function getComputedExpertises(role, expertises) {
  switch (role) {
    case appConstants.VALUE_INTEGRATOR:
      return expertises
        .filter(expertise => (expertise[appConstants.KEY_CATEGORY_DISPLAY_NAME] === appConstants.VALUE_SPECIALIZATIONS)||(expertise[appConstants.KEY_CATEGORY_DISPLAY_NAME] === appConstants.VALUE_PARTNER_SPECIALIZATIONS))
        .map(filteredExpertise => filteredExpertise[appConstants.KEY_KEYWORD_DISPLAY_NAME]);
    case appConstants.VALUE_PROVIDER:
      return expertises
        .filter(expertise => (expertise[appConstants.KEY_CATEGORY_DISPLAY_NAME] === appConstants.VALUE_PROVIDER_LEVEL_AND_CISCO_POWERED_SERVICES) &&
          !appConstants.PROVIDER_LEVELS.includes(expertise[appConstants.KEY_KEYWORD_DISPLAY_NAME].trim().toLowerCase()))
        .map(filteredExpertise => filteredExpertise[appConstants.KEY_KEYWORD_DISPLAY_NAME]);
    default:
      return []
  }
}

export default function PartnerComparator({className}) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);

  const { getTranslationFor } = useL18nContext();
  const translatedTitleBack = getTranslationFor(KEYS.L18N_KEY_LABEL_BACK);
  const translatedTitleRemovePartner = getTranslationFor(KEYS.L18N_KEY_LABEL_REMOVE_FROM_COMPARATOR);
  const translatedLabelRole = getTranslationFor(KEYS.L18N_KEY_LABEL_ROLE);
  const translatedLabelTechnologicalFocus = getTranslationFor(KEYS.L18N_KEY_LABEL_TECHNOLOGICAL_FOCUS);
  const translatedLabelIndustries = getTranslationFor(KEYS.L18N_KEY_LABEL_INDUSTRIES);
  const translatedLabelLevel = getTranslationFor(KEYS.L18N_KEY_LABEL_PARTNER_LEVEL);
  const translatedLabelDescription = getTranslationFor(KEYS.L18N_KEY_LABEL_DESCRIPTION);
  const translatedLabelDiversePartner = getTranslationFor(KEYS.L18N_KEY_LABEL_DIVERSE_PARTNER);

  const {selectPartnerSearchFeature} = useNavigationBetweenPartnerFeaturesContext();

  const {
    comparedItemList,
    comparedItemCategory,
    removeItemFromComparator
  } = usePartnerSearchContext();

  const history = useHistory();

  let computedExpertiseLabel = constants.NO_EXPERTISES;
  let showExpertises = false;
  switch(comparedItemCategory) {
    case appConstants.VALUE_INTEGRATOR :
      computedExpertiseLabel = getTranslationFor(KEYS.L18N_KEY_LABEL_SPECIALIZATIONS);
      showExpertises = true;
      break;
    case appConstants.VALUE_PROVIDER :
      computedExpertiseLabel = getTranslationFor(KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICES);
      showExpertises = true;
      break;
  }

  const [showMoreExpertises, setShowMoreExpertises] = useState([false,false,false,false]);
  const [showMoreTechnologies, setShowMoreTechnologies] = useState([false,false,false,false]);
  const [showMoreIndustries, setShowMoreIndustries] = useState([false,false,false,false]);
  const [showMoreDescriptions, setShowMoreDescriptions] = useState([false,false,false,false]);

  function toggleShowMoreLessExpertises(partnerIndex) { let newArray = [...showMoreExpertises]; newArray[partnerIndex]=!newArray[partnerIndex]; setShowMoreExpertises(previousValue=>newArray); }
  function toggleShowMoreLessTechnologies(partnerIndex) { let newArray = [...showMoreTechnologies]; newArray[partnerIndex]=!newArray[partnerIndex]; setShowMoreTechnologies(previousValue=>newArray); }
  function toggleShowMoreLessIndustries(partnerIndex) { let newArray = [...showMoreIndustries]; newArray[partnerIndex]=!newArray[partnerIndex]; setShowMoreIndustries(previousValue=>newArray); }
  function toggleShowMoreLessDescriptions(partnerIndex) { let newArray = [...showMoreDescriptions]; newArray[partnerIndex]=!newArray[partnerIndex]; setShowMoreDescriptions(previousValue=>newArray); }

  const computedCloseClickFn = handleClick(()=> {
    setShowMoreExpertises(previous => [false,false,false,false]);
    setShowMoreTechnologies(previous => [false,false,false,false]);
    setShowMoreIndustries(previous => [false,false,false,false]);
    setShowMoreDescriptions(previous => [false,false,false,false]);
    selectPartnerSearchFeature();
  });

  const translatedSeeMoreLabel = getTranslationFor(KEYS.L18N_KEY_LABEL_SEE_MORE);
  const translatedSeeLessLabel = getTranslationFor(KEYS.L18N_KEY_LABEL_SEE_LESS);

  return (
    <div className={computedClassName}>
      <button className="appearance-none absolute top-6 right-4 2xs:top-8 2xs:right-6 sm:top-10 sm:right-12 z-10"
              type="button"
              title={translatedTitleBack}
              onClick={computedCloseClickFn}>
        <span className="sr-only">{translatedTitleBack}</span>
        <CCIconClose20x20 className="text-cc-muted-contrast w-5 h-5 2xs:w-6 2xs:h-6 sm:w-8 sm:h-8" aria-hidden="true"/>
      </button>
      <div className="mx-auto max-w-full w-cc-screen-lg relative">
        <header className="mt-6 3xs:mt-12 2xs:mt-20 sm:mt-28 mb-4 3xs:mb-6 2xs:mb-12 flex flex-row items-center">
          <h1 className="text-cc-100 3xs:text-cc-200 2xs:text-cc-300 font-regular text-cc-muted-contrast">{getTranslationFor(KEYS.L18N_KEY_LABEL_PARTNER_COMPARISON)}</h1>
        </header>

        <div className="pf-c-grid-comparator relative overflow-x-auto text-cc-body-medium sm:text-cc-body-large">
          {
            comparedItemList.map(
              (comparedPartner, index) => {
                const partnerBeGeoId = comparedPartner?.be_geo_id||0;
                const partnerSiteId = comparedPartner?.site_id||0;
                const partnerName = comparedPartner?.partner_name||'';
                const partnerExpertises = showExpertises ? getComputedExpertises(comparedItemCategory, comparedPartner?.qualifications||[]):[];
                const partnerRolesAndLevels = comparedPartner?.rolesAndLevels||{};
                const computedPartnerLevel = partnerRolesAndLevels?.[comparedItemCategory]||'';
                let partnerTechnologies = comparedPartner?.technology_keywords || '';
                partnerTechnologies = partnerTechnologies === '' ? [] : partnerTechnologies.split(',');
                let partnerIndustries = comparedPartner?.industry_keywords || '';
                partnerIndustries = partnerIndustries === '' ? [] : partnerIndustries.split(',');
                const partnerDescription = comparedPartner?.note_text||getTranslationFor(KEYS.L18N_KEY_LABEL_NO_DESCRIPTION_PROVIDED_DOT);
                const partnerDiversityProgramNames = comparedPartner?.partnerDiversityProgramNames || [];
                const computedPartnerNameClickFn = handleEventClick(navigateToPartnerProfile, { history: history, partnerId: partnerSiteId } );
                const computedRemovePartnerClickFn = () => {
                  removeItemFromComparator(comparedPartner, appConstants.KEY_SITE_ID_LOWERCASE);
                  if(comparedItemList.length - 1 < appConstants.COMPARATOR_MIN_ITEM_COUNT_LIMIT) {
                    setShowMoreExpertises(previous => [false,false,false,false]);
                    setShowMoreTechnologies(previous => [false,false,false,false]);
                    setShowMoreIndustries(previous => [false,false,false,false]);
                    setShowMoreDescriptions(previous => [false,false,false,false]);
                    selectPartnerSearchFeature();
                  }
                }

                const partnerIndex = index + 1;
                const computedCloseLogoNameClassName =  getComputedCloseLogoNameClassName(partnerIndex);
                const computedSpecializationClassName =  getComputedSpecializationClassName(partnerIndex);
                const computedRoleClassName =  getComputedRoleClassName(partnerIndex);
                const computedTechnologyClassName =  getComputedTechnologyClassName(partnerIndex);
                const computedIndustryClassName =  getComputedIndustryClassName(partnerIndex);
                const computedLevelClassName =  getComputedLevelClassName(partnerIndex);
                const computedDescriptionClassName =  getComputedDescriptionClassName(partnerIndex);
                const computedDiversityClassName = getComputedDiversityClassName(partnerIndex);
                const computedGapHeaderClassName =  getComputedGapHeader(partnerIndex);
                const computedGapClassName =  getComputedGap(partnerIndex);

                const computedToggleExpertisesClick = handleEventClick(toggleShowMoreLessExpertises,partnerIndex - 1);
                const computedToggleTechnologiesClick = handleEventClick(toggleShowMoreLessTechnologies,partnerIndex - 1);
                const computedToggleIndustriesClick = handleEventClick(toggleShowMoreLessIndustries,partnerIndex - 1);
                const computedToggleDescriptionClick = handleEventClick(toggleShowMoreLessDescriptions, partnerIndex - 1);

                return (
                  <Fragment key={index}>
                    <div className={computedCloseLogoNameClassName}>
                      <button className="appearance-none absolute top-4 right-4"
                              type="button"
                              title={translatedTitleRemovePartner}
                              onClick={computedRemovePartnerClickFn}>
                        <span className="sr-only">{translatedTitleRemovePartner}</span>
                        <CCIconClose20x20 className="w-5 h-5" aria-hidden="true"/>
                      </button>
                      <div className="bg-cc-primary">
                        <PartnerLogo className="mb-4" partnerBeGeoId={partnerBeGeoId}/>
                        <p className="text-cc-100 font-normal bg-cc-primary text-cc-primary-contrast whitespace-nowrap truncate" title={partnerName}>
                          <a href="/" onClick={computedPartnerNameClickFn} className="text-cc-link">{partnerName}</a>
                        </p>
                      </div>
                    </div>
                    <div className={computedSpecializationClassName}>
                      {
                        showExpertises &&
                        <>
                          <h3 className="font-semibold mb-4">{computedExpertiseLabel}</h3>
                          <ul className="list-none text-cc-secondary-contrast">
                            {
                              partnerExpertises.map(
                                (expertise, index) => {
                                  if(!showMoreExpertises[partnerIndex - 1] && index + 1 > appConstants.COMPARATOR_LIST_ITEMS_SHOW_MAX) {
                                    return null;
                                  }
                                  else {
                                    return (<li className="mb-0.5" key={index}>{expertise}</li>)
                                  }
                                }
                              )
                            }
                          </ul>
                          {
                            !showMoreExpertises[partnerIndex - 1] && (partnerExpertises.length > appConstants.COMPARATOR_LIST_ITEMS_SHOW_MAX) &&
                            <p><a onClick={computedToggleExpertisesClick} href="/" className="text-cc-link">{translatedSeeMoreLabel}</a></p>
                          }
                          {
                            showMoreExpertises[partnerIndex - 1] && (partnerExpertises.length > appConstants.COMPARATOR_LIST_ITEMS_SHOW_MAX) &&
                            <p><a onClick={computedToggleExpertisesClick} href="/" className="text-cc-link">{translatedSeeLessLabel}</a></p>
                          }
                        </>
                      }
                    </div>
                    <div className={computedRoleClassName}>
                      <h3 className="font-semibold mb-4">{translatedLabelRole}</h3>
                      <p className="text-cc-secondary-contrast">{comparedItemCategory}</p>
                    </div>
                    <div className={computedTechnologyClassName}>
                      <h3 className="font-semibold mb-4">{translatedLabelTechnologicalFocus}</h3>
                      {
                        !!partnerTechnologies.length &&
                        <ul className="list-none text-cc-secondary-contrast">
                          {
                            partnerTechnologies.map(
                              (technology, index) => {
                                if(!showMoreTechnologies[partnerIndex - 1] && index + 1 > appConstants.COMPARATOR_LIST_ITEMS_SHOW_MAX) {
                                  return null;
                                }
                                else {
                                  return (<li className="mb-0.5" key={index}>{technology}</li>)
                                }
                              }
                            )
                          }
                        </ul>
                      }
                      {
                        !showMoreTechnologies[partnerIndex - 1] && (partnerTechnologies.length > appConstants.COMPARATOR_LIST_ITEMS_SHOW_MAX) &&
                        <p><a onClick={computedToggleTechnologiesClick} href="/" className="text-cc-link">{translatedSeeMoreLabel}</a></p>
                      }
                      {
                        showMoreTechnologies[partnerIndex - 1] && (partnerTechnologies.length > appConstants.COMPARATOR_LIST_ITEMS_SHOW_MAX) &&
                        <p><a onClick={computedToggleTechnologiesClick} href="/" className="text-cc-link">{translatedSeeLessLabel}</a></p>
                      }
                    </div>
                    <div className={computedIndustryClassName}>
                      <h3 className="font-semibold mb-4">{translatedLabelIndustries}</h3>
                      {
                        !!partnerIndustries.length &&
                        <ul className="list-none text-cc-secondary-contrast">
                          {
                            partnerIndustries.map(
                              (industry, index) => {
                                if(!showMoreIndustries[partnerIndex - 1] && index + 1 > appConstants.COMPARATOR_LIST_ITEMS_SHOW_MAX) {
                                  return null;
                                }
                                else {
                                  return (<li className="mb-0.5" key={index}>{industry}</li>)
                                }
                              }
                            )
                          }
                        </ul>
                      }
                      {
                        !showMoreIndustries[partnerIndex - 1] && (partnerIndustries.length > appConstants.COMPARATOR_LIST_ITEMS_SHOW_MAX) &&
                        <p><a onClick={computedToggleIndustriesClick} href="/" className="text-cc-link">{translatedSeeMoreLabel}</a></p>
                      }
                      {
                        showMoreIndustries[partnerIndex - 1] && (partnerIndustries.length > appConstants.COMPARATOR_LIST_ITEMS_SHOW_MAX) &&
                        <p><a onClick={computedToggleIndustriesClick} href="/" className="text-cc-link">{translatedSeeLessLabel}</a></p>
                      }
                    </div>
                    <div className={computedLevelClassName}>
                      <h3 className="font-semibold mb-4">{translatedLabelLevel}</h3>
                      <p className="text-cc-secondary-contrast">{computedPartnerLevel}</p>
                    </div>
                    <div className={computedDescriptionClassName}>
                      <h3 className="font-semibold mb-4">{translatedLabelDescription}</h3>
                      {
                        !showMoreDescriptions[partnerIndex - 1] && (partnerDescription.length > appConstants.COMPARATOR_LONG_TEXT_SHOW_MAX) &&
                        <p className="text-cc-secondary-contrast">{partnerDescription.slice(0,appConstants.COMPARATOR_LONG_TEXT_SHOW_MAX - 1)}...</p>
                      }
                      {
                        !showMoreDescriptions[partnerIndex - 1] && (partnerDescription.length <= appConstants.COMPARATOR_LONG_TEXT_SHOW_MAX) &&
                        <p className="text-cc-secondary-contrast">{partnerDescription}</p>
                      }
                      {
                        showMoreDescriptions[partnerIndex - 1] &&
                        <p className="text-cc-secondary-contrast">{partnerDescription}</p>
                      }

                      {
                        !showMoreDescriptions[partnerIndex - 1] && (partnerDescription.length > appConstants.COMPARATOR_LONG_TEXT_SHOW_MAX) &&
                        <p><a onClick={computedToggleDescriptionClick} href="/" className="text-cc-link">{translatedSeeMoreLabel}</a></p>
                      }
                      {
                        showMoreDescriptions[partnerIndex - 1] && (partnerDescription.length > appConstants.COMPARATOR_LONG_TEXT_SHOW_MAX) &&
                        <p><a onClick={computedToggleDescriptionClick} href="/" className="text-cc-link">{translatedSeeLessLabel}</a></p>
                      }
                    </div>
                    <div className={computedDiversityClassName}>
                      {
                        !!partnerDiversityProgramNames.length &&
                        <>
                          <h3 className="font-semibold mb-4">{translatedLabelDiversePartner}</h3>
                          <ul className="list-none text-cc-secondary-contrast">
                            {
                              partnerDiversityProgramNames.map(
                                (partnerDiversityProgramName, index) => {
                                    return (<li className="mb-0.5" key={index}>{partnerDiversityProgramName}</li>)
                                }
                              )
                            }
                          </ul>
                        </>
                      }
                    </div>
                    <div className={computedGapHeaderClassName}>&nbsp;</div>
                    <div className={computedGapClassName}>&nbsp;</div>
                  </Fragment>
                )
              }
            )
          }
        </div>

      </div>
    </div>
  )
}


//                         {
//                           !partnerTechnologies.length &&
//                           <p className="text-cc-gray-80">No technologies found.</p>
//                         }
